export const FILTER_FIELDS_LABELS = {
  hideFromReports: 'Hidden transactions',
  needsReview: 'Needs review',
  isSplit: 'Split transactions',
  hasNotes: 'Transactions with notes',
  hasAttachments: 'Transactions with attachments',
  isRecurring: 'Recurring transactions',
  needsReviewBy: 'Needs review by...',
};
